import React, { useState, useEffect } from 'react';
import { BaseTypography, BaseButton, FormikField} from 'src/components/common';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from "@material-ui/lab/Pagination";
import ImageOrVideo from '../../components/common/ImageOrVideo/ImageOrVideo';
import { Grid, styled } from '@material-ui/core';
  
const useStyles = makeStyles((theme) => ({
	articleDescription: {
		margin: '5px 0',
		color: '#555555',
		overflow: 'hidden',
		display: '-webkit-box',
		WebkitLineClamp: 4,
		WebkitBoxOrient: 'vertical',
		'& p': {
            margin: 0,
        },
	},
	blogpostContainer: {
		width: '100% !important',
		display: 'grid',
	    gridTemplateColumns: 'repeat(3, 1fr)',
	    gridColumnGap: '15px',
	    gridRowGap: '15px',
		'@media (max-width:1024px)': {
		  gridTemplateColumns: 'repeat(2, 1fr)',
		},
		'@media (max-width:768px)': {
		  gridTemplateColumns: 'repeat(1, 1fr)',
		}
	},  
	blogpostItem: {
		border: '1px solid #DBDBDB',
	},
	blogpostItemInner: {
		padding: '15px',

	},
	image:{
        maxWidth: '100% !important',
        '& iframe, video': {
            maxWidth: '100% !important',
          },
    },
	MuiPagination: {
		'& ul': {
			textAlign: 'center',
			display: 'block',
		},
		'& ul li': {
			display: 'inline-block',
			margin: '5px'
		},
		'& .active button': {
			backgroundColor: 'rgba(218, 239, 251, 0.3)',
			borderColor: '#0090E5',
			color: '#fff',
		},
		'& li button': {
			border: '1px solid #0090E5',
			padding: '6px 10px',
			outline: 'none',
			cursor: 'pointer',
			backgroundColor: 'rgba(218, 239, 251, 0.3)',
		},
		'& button.Mui-selected, & button.Mui-selected:hover, & button.Mui-selected:focus': {
			backgroundColor: '#0090E5',
			borderColor: '#0090E5',
			outline: 'none',
			color: '#FFFFFF'
		},
		'& li:first-child > button, & li:last-child > button': {
			borderRadius: 'unset',
		},
		'& .MuiPaginationItem-root': {
			borderRadius: '0'
		}
	},
	imgContainer: {
		'@media (min-width:769px)': {
			height: '194px',
			'& img': {
				width: '100% !important',
				height: '100%',
				objectFit: 'cover'
			}
		}
	}
}));

type PAutoCard = {
    response1: any;
};

const firstIndex = 0;

export const BlogPostsCard: React.FC<PAutoCard> = (props) => {
	  
  const { response1 } = props;
  const classes = useStyles();
  
  const [pageSize, setPageSize] = useState(6);
  const [page, setPage] = useState(1);
  const [data, setData] = useState(response1?.slice(firstIndex, pageSize));
  
  useEffect(() => {
	setData(response1?.slice(0, pageSize));
  }, [response1]);
    
  const handleChange = (event:any, value:any) => {
    setPage(value);
    setData(response1?.slice(firstIndex + pageSize * (value - 1), pageSize * value));
	window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
  };

  const changeWidth = (e:any) => {
    setPageSize(parseInt(e.target.value, 6));
  };
  
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
  
	let dataresult = '';
	if (data) {
		
	  dataresult = <div className={classes.blogpostContainer}>{data?.map((item: any) => {
		  return (
			
			  <div className={classes.blogpostItem} style={{ marginBottom: '30px' }}>
				<div className={classes.blogpostItemInner}>
				  <div className={classes.imgContainer}>
						<ImageOrVideo className={classes.image} src={item.picture ? item.picture : 'https://dev.api.contactsbook.asia/images/dummy-blog-img.jpg'} alt={item.picture} width="100% !important"/>
				  </div>
				  <BaseTypography variant="h3" style={{ lineHeight: '28px', minHeight: '55px', marginBottom: '10px', marginTop: '5px', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', color: 'rgb(0, 115, 201)' }}>
						  <a 
						href={`/blogpost/${item.slug}`}
						style={{ textDecoration: 'none', color: '#0073C9', fontSize: '18px', lineHeight: '23px' }}
						rel="noreferrer">{item.blog_title}</a>
					</BaseTypography>
					<BaseTypography gutterBottom="true" style={{ color: '#555555' }}>Publish Date: {new Date(item.created_at).toDateString().split(" ").splice(1, 4).join(" ")}</BaseTypography>
					<BaseTypography
                                variant="text"
                                dangerouslySetInnerHTML={{ __html : 
                                    item.blog_description
                                }}
                                className={classes.articleDescription} />	
					<BaseTypography variant="tag" className="pointer">
					  <a
						className="primary"
						href={`/blogpost/${item.slug}`}
						style={{ textDecoration: 'none' }}
						rel="noreferrer">
						Read full blog post
					  </a>
					</BaseTypography>
				</div>
			  </div>
		  );
	  })}</div>
	} else {
	  dataresult = <BaseTypography variant="h3" style={{ lineHeight: '28px', marginBottom: '10px' }}>
						  No Result Found
					</BaseTypography>;
	}
  
	return (
			<div>
			  {dataresult}
			  {response1?.length/pageSize > 1 &&
				  <Pagination className={classes.MuiPagination}
					count={Math.ceil(response1.length / pageSize)}
					page={page}
					onChange={handleChange}
				  />
			  }
			 </div>
	);
};
